import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApi,
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

type ReadCategoryTypesV3 = OpalApi<'ReadCategoryTypesV3', 200>

export const readCategoryTypes: ReadCategoryTypesV3 = async ({
  params,
}: Parameters<ReadCategoryTypesV3>[0] = {}) => {
  const url = new URL('/loupe/v3/category_types/', window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}

type ReadCategoryTypeOperation = 'ReadCategoryTypeV3'

export type ReadCategoryTypeResponse = OpalApiResponseDocument<
  ReadCategoryTypeOperation,
  200
>

export async function readCategoryType(
  params: OpalApiRequestParams<ReadCategoryTypeOperation>
): Promise<ReadCategoryTypeResponse> {
  const url = new URL(
    `/loupe/v3/category_types/${params.path.category_type_id}`,
    window.location.origin
  )

  const res = await HttpClient().get(url.toString())
  return res.data
}
